import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

import { useAppDispatch } from 'store';

import { setOpen } from '../store';

export const feedbackKey = 'pro_feedback_shown_at';

export function useExitFeedback() {
  const router = useRouter();
  const isModalShownRef = useRef(false);
  const pendingUrlRef = useRef<string | null>(null);
  const dispatch = useAppDispatch();

  const checkShouldShow = () => {
    const lastShown = localStorage.getItem(feedbackKey);

    if (!lastShown) return true;

    const lastDate = new Date(lastShown);
    const now = new Date();
    const diffDays = (now.getTime() - lastDate.getTime()) / (1000 * 60 * 60 * 24);

    return diffDays >= 7;
  };

  useEffect(() => {
    const handleRouteChangeStart = (url: string) => {
      const currentPath = router.pathname;

      if (isModalShownRef.current) return;

      if (currentPath === '/pro' && url.startsWith('/pro/payment')) return;

      const isLeavingPro = currentPath === '/pro' || currentPath === '/pro/payment';

      if (isLeavingPro && checkShouldShow()) {
        pendingUrlRef.current = url;
        isModalShownRef.current = true;
        localStorage.setItem(feedbackKey, new Date().toISOString());
        dispatch(setOpen(true));

        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw 'Route change aborted for feedback modal';
      }
    };

    router.events.on('routeChangeStart', handleRouteChangeStart);

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart);
    };
  }, [router, dispatch]);

  const continueNavigation = () => {
    const url = pendingUrlRef.current;

    if (url) {
      pendingUrlRef.current = null;
      isModalShownRef.current = false;
      router.push(url);
    }
  };

  return { continueNavigation };
}
